import { sub as r, startOfWeek as n, subWeeks as o, endOfWeek as u, startOfMonth as a, subMonths as s, endOfMonth as c, add as D, startOfDay as f } from "date-fns";
const e = (t) => D(f(t), { hours: 12 }), m = {
  custom: () => {
  },
  today: () => {
    const t = /* @__PURE__ */ new Date();
    return {
      from: e(t),
      to: e(t)
    };
  },
  yesterday: () => {
    const t = /* @__PURE__ */ new Date();
    return {
      from: r(e(t), { days: 1 }),
      to: r(e(t), { days: 1 })
    };
  },
  last7Days: () => {
    const t = /* @__PURE__ */ new Date();
    return {
      from: r(e(t), { days: 7 }),
      to: e(t)
    };
  },
  last30Days: () => {
    const t = /* @__PURE__ */ new Date();
    return {
      from: r(e(t), { days: 30 }),
      to: e(t)
    };
  },
  thisWeek: () => {
    const t = /* @__PURE__ */ new Date();
    return {
      from: e(n(t, { weekStartsOn: 1 })),
      to: e(t)
    };
  },
  lastWeek: () => {
    const t = /* @__PURE__ */ new Date();
    return {
      from: e(o(n(t, { weekStartsOn: 1 }), 1)),
      to: e(o(u(t, { weekStartsOn: 1 }), 1))
    };
  },
  thisMonth: () => {
    const t = /* @__PURE__ */ new Date();
    return {
      from: e(a(t)),
      to: e(t)
    };
  },
  lastMonth: () => {
    const t = /* @__PURE__ */ new Date();
    return {
      // calling subMonths first to ensure we're getting the last day of the month, even if the previous month is longer than the current month
      from: e(a(s(t, 1))),
      to: e(c(s(t, 1)))
    };
  }
};
export {
  m as periodFunctions
};
//# sourceMappingURL=periodFunctions.js.map
